module.exports = __webpack_public_path__ + "img/logo.9a8a6150.png";